import React, { useEffect, useState } from "react";
import { resolveStorageReference } from "../lib/storageReferences";

export default function StorageImage({ src, alt, className = "", ...props }) {
  const [resolvedSrc, setResolvedSrc] = useState("");

  useEffect(() => {
    let isMounted = true;

    const load = async () => {
      const nextSrc = await resolveStorageReference(src);
      if (isMounted) {
        setResolvedSrc(nextSrc || "");
      }
    };

    load();

    return () => {
      isMounted = false;
    };
  }, [src]);

  if (!src || !resolvedSrc) {
    return null;
  }

  return <img src={resolvedSrc} alt={alt} className={className} {...props} />;
}